import { camelCase } from 'camel-case';
import kebabCase from 'lodash-es/kebabCase';
import { snakeCase } from 'snake-case';
import { deepMapKeys } from './deep-map-keys';

export function transformToCamelCase<T>(
  data: T,
  ignoreList: ((payload: any) => boolean)[]
) {
  const shouldNotConvert = ignoreList.some((rule) => rule(data));
  if (shouldNotConvert) {
    return data;
  }
  return deepMapKeys<T>(data, camelCase);
}

export function transformToSnakeCase<T = Record<string, any>>(payload: T) {
  return deepMapKeys<T>(payload, snakeCase);
}

export function transformToKebabCase<T = Record<string, any>>(payload: T) {
  return deepMapKeys<T>(payload, kebabCase);
}
